import useWindowDimensions from "hooks/useWindowDimension";
import ShareDropdownMenu from "components/UI/Popups/ShareDropdownMenu";
import { Fragment } from "react";
import { SharePopup } from "components/UI/Popups/SharePopup";
import { IGif } from "services/types";

interface IProps {
  gif: IGif;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onOpenEmbed: () => void;
}

export const ShareGif = (props: IProps) => {
  const { gif, anchorEl, onClose, onOpenEmbed } = props;

  const isDesktop = useWindowDimensions();

  return (
    <Fragment>
      {
        isDesktop ? (
          <ShareDropdownMenu
            gif={gif}
            handleEmbedPopup={onOpenEmbed}
            anchorEl={anchorEl}
            handleClose={onClose}
          />
        ) : (
          <SharePopup
            isOpen={true}
            togglePopup={onClose}
            handleEmbedPopup={onOpenEmbed}
            gif={gif}
          />
        )
      }
    </Fragment>
  );
};
